export default class User {
  constructor({
    slug = null,
    nickname = null,
    pictureUrl = null,
    defaultLocale = null,
    settingsUpdatedAt = null,
  } = {}) {
    this.slug = slug;
    this.nickname = nickname;
    this.pictureUrl = pictureUrl;
    this.defaultLocale = defaultLocale;
    this.settingsUpdatedAt = settingsUpdatedAt;
  }

  managerUrl(tab = '') {
    return `/manager/${this.slug}?tab=${tab}`;
  }

  isSettingsCompleted() {
    return this.settingsUpdatedAt !== null;
  }

  static createFromObject(data) {
    return new User(data);
  }

  static createCollectionFromObject(data) {
    return data.map(
      (user) => User.createFromObject(user),
    );
  }
}
